import styled from "styled-components/macro";

import FnrCard from "UI/FnrCard/FnrCard";

const VerticallyCentered = styled("div")`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const IconContainer = styled("div")`
  ${({ $color = "fnDarkBlue", theme: { colors } }) => `
    color: ${colors[$color]};
`}
  font-size: 28px;
  width: 32px;
`;

const SFnrCard = styled(FnrCard)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// TODO: use the one from commonContainers.
const VerticalGap = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// TODO: use the one from commonContainers.
const HorizontalGap = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const Info = styled("div")`
  ${({
    theme: {
      colors: { textSecondary, textPrimary },
    },
  }) => `
display: inline;
& div {display: inline;}
color: ${textSecondary};
&:hover {color: ${textPrimary};}
transition: color .2s;
`}
`;

const extendedFieldInputContainers = {
  VerticallyCentered,
  IconContainer,
  SFnrCard,
  VerticalGap,
  HorizontalGap,
  Info,
};

export default extendedFieldInputContainers;
